module.exports = "/fonts/iconsmind.woff?5e5b709879b64c720a2c768a516ff0d3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/assets/fonts/iconsmind/iconsmind.woff?ioqkm7
// module id = QLXs
// module chunks = 35